import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { NoddiBasicCard, NoddiInput } from 'noddi-ui-web';
import {
  useContactFallbackActions,
  useContactFallbackEmail,
  useContactFallbackPhoneNumber
} from '../../stores/contactFallbackStore';

interface Props {
  showEmail: boolean;
  showPhone: boolean;
}

export const MissingContactInfoCard = ({ showEmail, showPhone }: Props) => {
  const email = useContactFallbackEmail();
  const phoneNumber = useContactFallbackPhoneNumber();
  const { setEmail, setPhoneNumber } = useContactFallbackActions();

  if (!showEmail && !showPhone) {
    return null;
  }

  return (
    <NoddiBasicCard className='flex flex-col gap-4'>
      <div className='flex flex-col gap-1'>
        <h2 className='text-lg font-semibold text-primary'>
          <Trans>Contact information</Trans>
        </h2>
        <span className='text-sm text-muted-foreground'>
          <Trans>We need your contact details before you can pay.</Trans>
        </span>
      </div>

      {showEmail && (
        <NoddiInput
          type='email'
          name='contact-email'
          label={t`Email`}
          placeholder={t`Email`}
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      )}
      {showPhone && (
        <NoddiInput
          type='tel'
          name='contact-phone'
          label={t`Phone number`}
          placeholder={t`Phone number`}
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
        />
      )}
    </NoddiBasicCard>
  );
};
